import { Component, HostBinding, Input } from '@angular/core';
import { PIXELIZATION_DELUXE_STORE_URL } from '../store-urls';

@Component({
    selector: 'app-pixelization-deluxe',
    templateUrl: './pixelization-deluxe.component.pug',
    styleUrls: ['./pixelization-deluxe.component.less']
})
export class PixelizationDeluxeComponent {
    @HostBinding('class.--ui') _ui = true;
    @Input() owned: boolean = false;

    storeUrl = PIXELIZATION_DELUXE_STORE_URL;
}
